/* CSS imports */

import "./assets/fonts/montserrat.css";

import "material-icons/css/material-icons.min.css";
import "izitoast/dist/css/iziToast.min.css";
import "smooth-scrollbar/dist/smooth-scrollbar.css";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/dark.css";
/*import 'flatpickr/dist/themes/airbnb.css'*/
import "./assets/styles/reset.css";
import "./assets/styles/main.css";
import "./assets/styles/dark-theme.css";

import "./assets/styles/global.scss"

import "./utils/resize-listener";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

/* Vue imports */

import Vue from "vue";
import VeeValidate from 'vee-validate'
import Resource from "vue-resource";
import Router from "vue-router";
import VueTheMask, { TheMask } from "vue-the-mask";
import VueModal from "vue-js-modal";
import VueTimeago from "vue-timeago";
import VueResize from "vue-resize";
import VueTippy from "vue-tippy";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueTextareaAutosize from 'vue-textarea-autosize'
import VueHighlight from 'vue-highlight-words'
import VueGravatar from 'vue-gravatar'
import VueMoney from "v-money";
import { Slider as ColorSlider } from 'vue-color'
import VueImageCropUpload from 'vue-image-crop-upload'
import AsyncComputed from 'vue-async-computed'

import ElementPtBr from "element-ui/lib/locale/lang/pt-br";
import ElementLocale from "element-ui/lib/locale";

import App from "./App.vue";

/* App imports */

import config from "./config"
import utils from "./utils/index"
import routes from "./routes"
import store from "./vuex/store"

import AuthAPI from "./api/auth"

/* Plugins imports */

import moment from "moment"
import _ from "lodash"
import SocketIO from "socket.io-client"
import Howler, { Howl } from 'howler'

import Map from "./helpers/Map"
import SlidingMaker from 'marker-animate-unobtrusive'
SlidingMaker.initializeGlobally()

// or import all icons if you don't care about bundle size
import "vue-awesome/icons"
import VIcon from "vue-awesome/components/Icon"

Number.prototype.round = function(places) {
    return +(Math.round(this + "e+" + places)  + "e-" + places)
}

/* Set Vue */
Vue.set(Vue.prototype, "_", _)
Vue.set(Vue.prototype, "moment", moment)
Vue.set(Vue.prototype, "config", config)
Vue.set(Vue.prototype, "utils", utils)

Vue.set(Vue.prototype, "sound", new Howl({
    volume: 0.3,
    src: [require('./assets/sounds/message.mp3')]
}))

Vue.set(Vue.prototype, 'soundNewRequest', new Howl({
    volume: 0.3,
    src: [require('./assets/sounds/new-request.mp3')]
}))

function exportModelsVuexORM() {
    let imports = []
    require.context('./vuex/models', true, /\.js$/)
        .keys()
        .forEach((path, i) => {
            if(path != './index.js') imports.push(path)
        })

    let obj = {}
    imports.forEach((value) => {
        let modelName = value.replace('./', '').replace('.js', '').trim()
        Object.defineProperty(obj, [modelName], { value: require(`./vuex/models/${modelName}`).default })
    })
    Vue.set(Vue.prototype, 'VXORM', obj)
}

exportModelsVuexORM()

Vue.use(Map)

Vue.set(Vue.prototype, "$socket", SocketIO(config.socketServer, {
    autoConnect: false
}))

/* Resource Configs */

Vue.use(Resource);

/* Socket.io */

/*Vue.use(new VueSocketIO({
    debug: true,
    connection: SocketIO(config.socketServer, {
        autoConnect: false
    }), //options object is Optional
    vuex: {
        store,
        actionPrefix: "SOCKET_",
        mutationPrefix: "SOCKET_"
    }
}))*/

/* Vue Plugins */

Vue.use(VueTimeago, {
    name: "timeago", // component name, `timeago` by default
    locale: "pt-BR",
    locales: {
        // you will need json-loader in webpack 1
        "pt-BR": require("vue-timeago/locales/pt-BR.json")
    }
});

Vue.component('v-highlight', VueHighlight)

Vue.component('v-slider-color-picker', ColorSlider)

Vue.use(AsyncComputed)

Vue.use(VueTextareaAutosize)

Vue.use(VueTheMask);

Vue.use(VueResize);

Vue.use(VueModal);

Vue.use(VueTippy);

Vue.use(VueTextareaAutosize)

import validationMessages from 'vee-validate/dist/locale/pt_BR';
Vue.use(VeeValidate, {
    locale: 'pt-br',
    dictionary: {
        'pt-br': validationMessages
    }
})

Vue.component("v-icon", VIcon)

Vue.component('vue-image-crop-upload', VueImageCropUpload)

Vue.use(VueMoney, {
    decimal: ",",
    thousands: ".",
    prefix: "",
    suffix: "",
    precision: 2,
    masked: false
})

/* Mask */

Vue.component("app-mask", TheMask);
Vue.component("app-perfect-scrollbar", VuePerfectScrollbar);
/* Element eleme */

ElementLocale.use(ElementPtBr);
import { DatePicker, TimeSelect, TimePicker, Slider } from "element-ui";

Vue.component("app-slider", Slider);
Vue.component(DatePicker.name, DatePicker);
Vue.component(TimeSelect.name, TimeSelect);
Vue.component(TimePicker.name, TimePicker);

Vue.component('app-gravatar', VueGravatar);

/* Router Configs*/

Vue.use(Router);

/* Components */

import FlatPickrComponent from "vue-flatpickr-component";
Vue.component("app-datetime-selector", FlatPickrComponent);
import PanelLoadingComponent from "./components/Utilities/PanelLoading.vue";
Vue.component("app-panel-loading", PanelLoadingComponent);
import SelectComponent from "./components/Inputs/Select.vue";
Vue.component("app-select", SelectComponent);
import DropdownMenuComponent from "./components/Utilities/DropdownMenu.vue";
Vue.component("app-dropdown-menu", DropdownMenuComponent);
import SwitchComponent from "./components/Forms/Switch.vue";
Vue.component("app-switch", SwitchComponent);
import CheckboxInputComponent from "./components/Inputs/CheckboxInput.vue";
Vue.component("app-checkbox", CheckboxInputComponent);
import PopoverComponent from "./components/Utilities/Popover.vue";
Vue.component("app-popover", PopoverComponent);
import ContainerLoadingComponent from './components/Utilities/ContainerLoading.vue'
Vue.component('app-container-loading', ContainerLoadingComponent)
import ModalComponent from './components/Utilities/Modal.vue'
Vue.component('app-modal', ModalComponent)

import VuexORMTextInputComponent from "./components/VuexORM/TextInput.vue";
Vue.component("app-text-input", VuexORMTextInputComponent);


import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)

Vue.component('fa', FontAwesomeIcon)

/* icons from src/assets/svgs */

import Icon from './components/Utilities/Icon/Icon.vue'
Vue.component("icon", Icon)

require
    .context("./assets/svgs/icons/", true, /\.svg$/)
    .keys()
    .forEach(svgFile => {
        const svgFilePath = svgFile.split(".")[1].replace("/", "");
        const svgFileName = _.last(svgFilePath.split("/"));
        Vue.component(
            "icon-" + svgFileName,
            require("./assets/svgs/icons/" + svgFilePath + ".svg")
        );
    });

require
    .context("./assets/svgs/header-icons/", true, /\.svg$/)
    .keys()
    .forEach(svgFile => {
        const svgFilePath = svgFile.split(".")[1].replace("/", "");
        const svgFileName = _.last(svgFilePath.split("/"));
        Vue.component(
            "icon-" + svgFileName,
            require("./assets/svgs/header-icons/" + svgFilePath + ".svg")
        );
    });

require
    .context("./assets/svgs/menu-icons/", true, /\.svg$/)
    .keys()
    .forEach(svgFile => {
        const svgFilePath = svgFile.split(".")[1].replace("/", "");
        const svgFileName = _.last(svgFilePath.split("/"));
        Vue.component(
            "menu-icon-" + svgFileName,
            require("./assets/svgs/menu-icons/" + svgFilePath + ".svg")
        );
    });

require
    .context("./assets/svgs/request-board-icons/", true, /\.svg$/)
    .keys()
    .forEach(svgFile => {
        const svgFilePath = svgFile.split(".")[1].replace("/", "");
        const svgFileName = _.last(svgFilePath.split("/"));
        Vue.component(
            "request-board-icon-" + svgFileName,
            require("./assets/svgs/request-board-icons/" + svgFilePath + ".svg")
        );
    });

require
    .context("./assets/svgs/section-icons/", true, /\.svg$/)
    .keys()
    .forEach(svgFile => {
        const svgFilePath = svgFile.split(".")[1].replace("/", "")
        const svgFileName = _.last(svgFilePath.split("/"))
        Vue.component(
            "icon-" + svgFileName,
            require("./assets/svgs/section-icons/" + svgFilePath + ".svg")
        )
    })

require
    .context("./assets/imgs/form-instructions/", true, /\.svg$/)
    .keys()
    .forEach(svgFile => {
        const svgFilePath = svgFile.split(".")[1].replace("/", "")
        const svgFileName = _.last(svgFilePath.split("/"))
        Vue.component(
            "img-" + svgFileName,
            require("./assets/imgs/form-instructions/" + svgFilePath + ".svg")
        )
    })

/* Global configs */

moment.locale("pt-br")

const router = new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes
})

/* Login Guard */

router.beforeEach((to, from, next) => {
    if (!store.state.auth.isAuthenticated && to.path !== "/login" && 
        to.path.indexOf('/invite') != 0 &&
        to.path.indexOf('/recovery-password') != 0){
        return next('/login')
    }
    if(store.state.auth.isAuthenticated && to.path !== "/changelog" && store.state.showChangelog) {
        store.dispatch('setShowChangelog',false)
        return next('/changelog')
    }
    document.title = to.meta.title
    next()
});

/* Request interceptors */

Vue.http.interceptors.push((request, next) => {
    if (store.state.auth.isAuthenticated) {
        request.params["token"] = store.state.auth.accessToken
    }
    next(response => {
        if(_.get(response, "body.error.code", false) === "EXPIRED_TOKEN" && response.status === 401){
            console.log("AccessToken expirado, tentativa de renovação do token usando o refreshToken", store.state.auth.tokens.refreshToken)
            return AuthAPI.refreshToken(store.state.auth.tokens.refreshToken).then(result => {
                store.dispatch("auth/refreshToken", { accessToken: result.data.accessToken, refreshToken: result.data.refreshToken })
                console.log("Refresh token adquirido com sucesso!", result)
                return Vue.http(request)
            }).catch(async err => {
                console.log("Não foi possível renovar o token, redirecionando para a tela de entrada")
                const authenticated = await store.dispatch("auth/logout")
                if (!authenticated) {
                    location.reload()
                }
            })
        }
        else if(!response.ok){
            // connection unreached to the server
            if(response.status === 0) { 
                console.log('Sem conexão com a internet.')
                store.dispatch('toast/showError', 'Sem conexão com a internet.')
                return
            }
            // console.log("Erroo teste", request, response)
        }
    })
})

/* Global Event Bus */

let EventBus = new Vue();

Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function() {
            return EventBus;
        }
    }
})

new Vue({
    router,
    el: "#app",
    render: h => h(App)
});

/* Prototype */

Array.prototype.asyncForEach = async function asyncForEach(callback) {
    for (let index = 0; index < this.length; index++) {
        await callback(this[index], index, this);
    }
}
